import Address from 'data/Address';
import { CreditDetails, CreditInfo } from './VendorCompany';

export default interface BusinessUnitCompany {
  id: number;
  businessUnitId: number;
  companyId: string;
  businessUnitCompanyId: string;
  creditId?: string;
  creditSource?: string;
  sapittKey?: string;
  distributionChannel?: string;
  division?: string;
  operationalApprover?: string;
  creditDetails?: CreditDetails;
  businessUnit?: {
    id: number;
    name: string;
    code: string;
    vendorId: number;
  };
  company?: {
    id: number;
    displayName: string;
    companyId: string;
    address?: Pick<Address, 'addressLine1' | 'addressLine2' | 'town' | 'region' | 'countryIsoCode' | 'postalCode'>;
  };
};

export interface BusinessUnitCompanyInfo {
  id: number;
  businessUnitId: number;
  companyId: string;
  businessUnitCompanyId: string;
  creditId?: string;
  hasCredit: boolean;
  businessUnitName?: string;
  businessUnitCode?: string;
  creditSource?: string;
};

export const emptyBusinessUnitCompanyInfo: BusinessUnitCompanyInfo = {
  id: 0,
  businessUnitId: 0,
  companyId: '',
  businessUnitCompanyId: '',
  hasCredit: false,
  businessUnitName: '',
  businessUnitCode: ''
};

export interface BusinessUnitCompanyDetailsCredit {
  creditId?: string;
  businessUnitCompanyId: string;
  id: number;
  address: Pick<Address, 'addressLine1' | 'addressLine2' | 'town' | 'region' | 'countryIsoCode' | 'postalCode'>;
}

export const emptyBusinessUnitCompanyDetailsCredit: BusinessUnitCompanyDetailsCredit = {
  creditId: '',
  businessUnitCompanyId: '',
  id: 0,
  address: {
    addressLine1: '',
    addressLine2: '',
    town: '',
    region: '',
    countryIsoCode: '',
    postalCode: '',
  }
};
